import { ref } from 'vue'

export function useTheme() {
  const isDarkMode = ref(false)

  const applyTheme = dark => {
    isDarkMode.value = dark
    document.documentElement.classList.toggle('dark', dark)
  }

  const toggleTheme = () => {
    applyTheme(!isDarkMode.value)
    localStorage.setItem('theme', isDarkMode.value ? 'dark' : 'light')
  }

  // Call once on mount — reads saved preference, falling back to the OS setting.
  const initTheme = () => {
    const saved = localStorage.getItem('theme')
    if (saved === 'dark' || (!saved && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      applyTheme(true)
    }
  }

  return { isDarkMode, toggleTheme, initTheme }
}
